import { useQuery } from '@tanstack/react-query';

import { getZillowPriceByZipCode } from '@arrived/api_v2';
import { ZillowPriceZipCode, ZipCode } from '@arrived/models';

import { MAX_STALE_TIME, UseQueryOptions, UseQueryResult } from '../queries.utils';
import { zillowPriceByZipCodeKeyFn } from './misc.keys';

export function useZillowPriceByZipCodeQuery(
  zipCode: ZipCode,
  from: Date,
  options?: UseQueryOptions<ZillowPriceZipCode[]>
): UseQueryResult<ZillowPriceZipCode[]> {
  return useQuery(zillowPriceByZipCodeKeyFn(zipCode, from), async () => getZillowPriceByZipCode(zipCode, from), {
    ...options,
    staleTime: options?.staleTime ?? MAX_STALE_TIME,
  });
}
